import React from 'react';
// eslint-disable-next-line import/no-unresolved
import placeholder from 'assets/resources/icon/backend.svg';
import ImgHTML from './ImgHTML';

const WrongImagePlaceholder = () => {
  return (
    <div className="wrong-image-placeholder gatsby-image-wrapper">
      <span>Warning: incorrect image format.</span>
      <ImgHTML src={placeholder} alt="No photo available" />
    </div>
  );
};

export default WrongImagePlaceholder;
